module.exports = __webpack_public_path__ + "img/left-arrow-disable.3e0d592f.svg";